// Layout/Dock — the phone's bottom dock (≤768px): the first four places the
// tenant can go plus "More", which opens a sheet with the whole navigation in its
// Work / Money / Setup groups. Same source as the rail (shellNav).
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FiGrid } from 'react-icons/fi';
import Sheet from '../ui/Sheet';
import useShellNav from './shellNav';
import navIcon from './navIcons';

const PRIMARY = 4;

export default function Dock() {
  const navigate = useNavigate();
  const { items, groups } = useShellNav();
  const [more, setMore] = useState(false);
  // The four places a thumb reaches: the registry's first four pages. AI Proposals
  // is a review queue, not a place you live — it sits in More and its pending
  // count shows on the More button.
  const primary = items.filter((i) => i.path !== '/ai/proposals').slice(0, PRIMARY);
  const rest = items.filter((i) => !primary.includes(i));
  const restActive = rest.some((i) => i.active);
  const restBadge = rest.reduce((n, i) => n + (i.badge || 0), 0);
  const go = (path) => { setMore(false); navigate(path); };
  return (
    <>
      <nav className="dock" aria-label="Primary">
        {primary.map((item) => (
          <NavLink key={item.path} to={item.path} className={`dock__item ${item.active ? 'is-active' : ''}`} aria-current={item.active ? 'page' : undefined}>
            <span className="dock__icon">{navIcon(item.icon, 22)}{item.badge > 0 ? <span className="dock__badge">{item.badge > 99 ? '99+' : item.badge}</span> : null}</span>
            <span className="dock__label">{item.label}</span>
          </NavLink>
        ))}
        <button type="button" className={`dock__item ${restActive || more ? 'is-active' : ''}`} onClick={() => setMore(true)} aria-haspopup="dialog" aria-expanded={more}>
          <span className="dock__icon"><FiGrid size={22} aria-hidden="true" />{restBadge > 0 ? <span className="dock__badge" aria-label={`${restBadge} pending`}>{restBadge > 99 ? '99+' : restBadge}</span> : null}</span>
          <span className="dock__label">More</span>
        </button>
      </nav>
      <Sheet open={more} onClose={() => setMore(false)} title="Go to" className="dock-sheet">
        {groups.map((g) => (
          <section key={g.key} className="dock-sheet__group" aria-label={g.label}>
            <h3 className="dock-sheet__label">{g.label}</h3>
            <div className="dock-sheet__grid">
              {g.items.map((item) => (
                <button key={item.path} type="button" className={`dock-sheet__item ${item.active ? 'is-active' : ''}`} onClick={() => go(item.path)}>
                  <span className="dock-sheet__icon">{navIcon(item.icon, 22)}</span>
                  <span className="dock-sheet__text">{item.label}</span>
                </button>
              ))}
            </div>
          </section>
        ))}
      </Sheet>
    </>
  );
}
